import { TranslatableStringType } from 'src/app/core/i18n/types';
import { TableColumn } from '../interfaces/table-column';

export const translateColumnHeaders =
  (columns: TableColumn[]) =>
  (translations: Record<string, TranslatableStringType>): TableColumn[] =>
    columns.map((column) => ({
      ...column,
      header: translations[column.header] || column.header,
      headerTooltip: column.headerTooltip
        ? translations[column.headerTooltip] || column.headerTooltip
        : column.headerTooltip,
    }));
